import React from "react";
import * as S from "./styles";

import Alert from "./components/Alert";
import ProcessorSelector from "./components/ProcessorSelector";
import usePermissionsManagement from "./usePermissionManagement";
import { ConfirmationModal } from "../../components/ConfirmationModal";
import Loading from "../../components/Loading";

const PermissionsManagement = () => {
  const {
    permissions,
    isModalOpen,
    openConfirmation,
    confirmChange,
    cancelChange,
    isLoading,
    isLoadingPermissions,
  } = usePermissionsManagement();

  return (
    <S.Container>
      <S.TitleWrapper>
        <S.PageTitle>Gestão de Permissões</S.PageTitle>
        <S.Separator />
      </S.TitleWrapper>

      <S.SubTileWrapper>
        <S.SubTitle>Permissões por Processadora</S.SubTitle>
      </S.SubTileWrapper>

      <S.Content>
        {isLoadingPermissions ? (
          <S.LoadingContainer>
            <Loading />
          </S.LoadingContainer>
        ) : (
          <>
            <ProcessorSelector
              title="Parcelamento com entrada personalizada"
              checkedDock={permissions.installment.dock}
              checkedCards={permissions.installment.cards}
              onCheckDock={() => openConfirmation("installment", "dock")}
              onCheckCards={() => openConfirmation("installment", "cards")}
            />

            <ProcessorSelector
              title="Ajuste retroativo"
              checkedDock={permissions.retroactive.dock}
              checkedCards={permissions.retroactive.cards}
              onCheckDock={() => openConfirmation("retroactive", "dock")}
              onCheckCards={() => openConfirmation("retroactive", "cards")}
            />

            <ProcessorSelector
              title="Antecipação de venda"
              checkedDock={permissions.antecipateSales.dock}
              checkedCards={permissions.antecipateSales.cards}
              onCheckDock={() => openConfirmation("antecipateSales", "dock")}
              onCheckCards={() => openConfirmation("antecipateSales", "cards")}
            />

            <Alert />
          </>
        )}
      </S.Content>

      {isModalOpen && (
        <ConfirmationModal
          title="Gestão de Permissões"
          description="Tem certeza que deseja atualizar a permissão?"
          isLoading={isLoading}
          onSubmit={confirmChange}
          onClose={cancelChange}
        />
      )}
    </S.Container>
  );
};

export default PermissionsManagement;
